import React from 'react'
import './HazardLabel.scss'

// This a single hazard image.
function HazardLabel (props) {
  return <div className={['hazard-label', props.kind].join(' ')} />
}

export default HazardLabel
